export default __webpack_public_path__ + "media/images/react_icons/sea-view-6c75031c8b94ad2ca6e7d50c91f94428.svg";